<script setup lang="ts">
import { computed } from 'vue';
import SmartGateAutocomplete from '@satellite/components/elements/forms/SmartGateAutocomplete.vue';
import CustomFieldLabel from './custom_fields/components/CustomFieldLabel.vue';
import useAxiosClient from './composables/useAxiosClient';

type SelectedItem = { name: string } | null;

const props = withDefaults(
  defineProps<{
    warehouseId: string;
    fieldLabel: string;
    fieldName: string;
    fieldMaxLength?: number;
    placeholder: string;
    testId: string;
    customItemClass: string;
    dataMapper: (item: Record<string, unknown>) => SelectedItem | undefined;
    rules?: unknown[];
    modelValue?: SelectedItem;
  }>(),
  {
    fieldMaxLength: 8,
    rules: () => [],
    modelValue: null
  }
);

const emit = defineEmits<{
  'update:model-value': [value: SelectedItem];
}>();

const axiosClient = useAxiosClient();

const cssFieldClassName = computed(() => props.customItemClass);

const fetcher = (warehouseId: string, signal?: AbortSignal) =>
  axiosClient
    .get(`/observations/public/${warehouseId}/autocomplete`, { signal })
    .then((r: { data: Record<string, unknown>[] | null }) => r.data || []);
</script>

<template>
  <div class="comet-i18n-exclude">
    <custom-field-label :field="{ label: fieldLabel, required: true }" />

    <div
      :class="`base-smartgate-autocomplete-select-container autocomplete-select-${cssFieldClassName}`">
      <SmartGateAutocomplete
        :data-testid="testId"
        :warehouse-id="warehouseId"
        :data-mapper="dataMapper"
        :field-name="fieldName"
        :placeholder="placeholder"
        :maxlength="fieldMaxLength"
        :model-value="modelValue"
        :rules="rules"
        :fetcher="fetcher"
        @update:model-value="emit('update:model-value', $event)" />
    </div>
  </div>
</template>

<style lang="scss">
.base-smartgate-autocomplete-select-container {
  position: relative;
}
.base-smartgate-autocomplete-select-container
  .v-menu
  > .v-overlay__content.v-autocomplete__content {
  top: 57px !important;
}
</style>
